import { createRootRoute } from '@tanstack/react-router';

import { RootLayout } from 'src/app';

// Create root route
export const rootRoute = createRootRoute({
  component: () => <RootLayout />,
});
